import { Alert, Button, useTheme } from "@mui/material";
import { authFlowHeaderIcons } from "./authFlowHeaderIcons";
import {
  getLoginPrimaryButtonSx,
  LoginCardContent,
  LoginFormHeader,
} from "./loginUi";

export type SmsNotPossibleProps = {
  loginUrl?: string;
  translations: {
    verifyIdentity: string;
    smsNotPossible: string;
    backToLogin: string;
  };
};

export const SmsNotPossible = ({
  loginUrl = "/accounts/login/",
  translations: t,
}: SmsNotPossibleProps) => {
  const theme = useTheme();

  return (
    <LoginCardContent testId="sms-not-possible">
      <LoginFormHeader
        title={t.verifyIdentity}
        headerIcon={authFlowHeaderIcons.smsNotPossible}
        headerTestId="sms-not-possible-header"
        titleTestId="sms-not-possible-title"
        headerIconTestId="sms-not-possible-header-icon"
      />

      <Alert severity="warning" sx={{ mb: 3 }}>
        {t.smsNotPossible}
      </Alert>

      <Button
        href={loginUrl}
        fullWidth
        variant="contained"
        size="large"
        data-testid="back-to-login-button"
        sx={getLoginPrimaryButtonSx(theme)}
      >
        {t.backToLogin}
      </Button>
    </LoginCardContent>
  );
};
